import { render } from "./ListComissionamento.vue?vue&type=template&id=5027d6d0&scoped=true"
import script from "./ListComissionamento.vue?vue&type=script&lang=js"
export * from "./ListComissionamento.vue?vue&type=script&lang=js"

import "./ListComissionamento.vue?vue&type=style&index=0&id=5027d6d0&scoped=true&lang=css"
import "./ListComissionamento.vue?vue&type=style&index=1&id=5027d6d0&lang=scss&scoped=true"
import "./ListComissionamento.vue?vue&type=style&index=2&id=5027d6d0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5027d6d0"]])

export default __exports__